import AxiosConfig from '@/config/axios-config'

export const CursoAPI = {

  listar (pagina = null, filtro = []) {
    return AxiosConfig.jalekoAPI().get('/admin/cursos',
      {
        params: {
          page: pagina,
          curso: filtro.curso,
          tipo_status_curso_id: filtro.status_id,
          empresa_criadora_id: filtro.empresa_id,
          atualizado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          atualizado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : ''
        }
      }).then(response => response.data)
  },

  salvar (curso) {
    let formData = new FormData()
    for (var key in curso) {
      if (key === 'planos_ids') {
        for (var index in curso['planos_ids']) {
          formData.append('planos_ids[]', curso['planos_ids'][index])
        }
      } else {
        formData.append(key, curso[key])
      }
    }
    return AxiosConfig.secureJalekoAPI().post('/admin/cursos', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  editar (curso) {
    let formData = new FormData()
    for (var key in curso) {
      if (key === 'planos_ids') {
        for (var index in curso['planos_ids']) {
          formData.append('planos_ids[]', curso['planos_ids'][index])
        }
      } else {
        formData.append(key, curso[key])
      }
    }
    return AxiosConfig.secureJalekoAPI().post(`/admin/cursos/${curso.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  deletar (curso) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/cursos/${curso.id}`, curso).then(response => response.data)
  },

  listarTipos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/cursos/tipo').then(response => response.data)
  },

  listarPlanos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/planosMacro',
      {
        params: {
          b2b: 0
        }
      }).then(response => response.data.planosMacros)
  },

  listarCursoPorId (id) {
    return AxiosConfig.secureJalekoAPI().get(`/admin/curso/${id}`).then(response => response.data)
  }

}

export default CursoAPI
